import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

// page
const PlatformView = () => import('@/views/PlatformView');
const RemoteView = () => import('@/views/RemoteView');
const LandingView = () => import('@/views/LandingView');

// one depth
const Appointments = () => import('@/components/body/appointments');
const PatientList = () => import('@/components/body/patientList');
const OptionDashboard = () => import('@/components/body/optionDashboard');
const RehabDashboard = () => import('@/components/body/rehabDashboard');
const Login = () => import('@/components/landing/login');
const Payments = () => import('@/components/body/payments')

// two depth
const List = () => import('@/components/body/patientList/list');
const Details = () => import('@/components/body/myPatient');
const FindPw = () => import('@/components/landing/findPw');
const SignUp = () => import('@/components/landing/signUp');
const PaymentLanding = () => import('@/components/body/payments/landing');
const PaymentInfo = () => import('@/components/body/payments/info');
const PaymentResult = () => import('@/components/body/payments/result');

// local
const Info = () => import('@/components/body/myPatient/info');
const Home = () => import('@/components/body/myPatient/report/reportItem/romChangeMonitoringGraph');
const Note = () => import('@/components/body/myPatient/note');
const History = () => import('@/components/body/myPatient/history/index');
const Remote = () => import('@/components/body/myPatient/remote/index');
const Rehab = () => import('@/components/body/myPatient/rehab/index');
const Report = () => import('@/components/body/myPatient/report/index');

// error handling
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    return onResolve || onReject
        ? originalPush.call(this, location, onResolve, onReject)
        : originalPush.call(this, location)?.catch((err) => {
            return VueRouter.isNavigationFailure(err) ? err : Promise.reject(err)
        })
}

const checkIfHasId = (id, next) => {
    id ? next() : next('/patientList')
}

const checkIsAuth = (to, next) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
        return next()
    } else {
        let path = '/login'
        if (to.query?.lang) {
            path += `/?lang=${to.query.lang}`
        }
        next({path: path})
    }
}

const routes = [
    {
        path: '',
        component: PlatformView,
        beforeEnter(to, _from, next) {
            checkIsAuth(to, next);
        },
        children: [
            {
                path: '',
                component: Appointments
            },
            {
                path: '/appointments',
                component: Appointments
            },
            {
                path: '/patientList',
                component: PatientList,
                children: [
                    {
                        path: '',
                        component: List
                    },
                    {
                        path: 'details',
                        component: Details,
                        children: [
                            {
                                path: '',
                                component: Home,
                                beforeEnter(to, _from, next) {
                                    checkIfHasId(to.query.id, next);
                                }
                            },
                            {
                                name: 'home',
                                path: 'home',
                                component: Home,
                                beforeEnter(to, _from, next) {
                                    checkIfHasId(to.query.id, next);
                                }
                            },
                            {
                                name: 'info',
                                path: 'info',
                                component: Info,
                                beforeEnter(to, _from, next) {
                                    checkIfHasId(to.query.id, next);
                                }
                            },
                            {
                                name: 'note',
                                path: 'note',
                                component: Note,
                                beforeEnter(to, _from, next) {
                                    checkIfHasId(to.query.id, next);
                                }
                            },
                            {
                                name: 'remote',
                                path: 'remote',
                                component: Remote,
                                beforeEnter(to, _from, next) {
                                    checkIfHasId(to.query.id, next);
                                }
                            },
                            {
                                name: 'rehab',
                                path: 'rehab',
                                component: Rehab,
                                beforeEnter(to, _from, next) {
                                    checkIfHasId(to.query.id, next);
                                }
                            },
                            {
                                name: 'history',
                                path: 'history',
                                component: History,
                                beforeEnter(to, _from, next) {
                                    checkIfHasId(to.query.id, next);
                                }
                            },
                            {
                                name: 'report',
                                path: 'report',
                                component: Report,
                                beforeEnter(to, _from, next) {
                                    checkIfHasId(to.query.id, next);
                                }
                            }
                        ],
                    }
                ]
            },
            {
                path: '/rehab',
                component: RehabDashboard
            },
            {
                path: '/options',
                component: OptionDashboard
            },
            {
                path: '/payments',
                component: Payments,
                children: [
                    {
                        path: '',
                        component: PaymentLanding
                    },
                    {
                        name: 'paymentInfo',
                        path: 'paymentInfo',
                        component: PaymentInfo,
                        beforeEnter(_to, from, next) {
                            if (from.name === 'result' && from.params.result.status === 'success') {
                                next('/options');
                            } else {
                                next();
                            }
                        }
                    },
                    {
                        name: 'result',
                        path: 'result',
                        component: PaymentResult,
                        beforeEnter(to, _from, next) {
                            if (to.params.hasOwnProperty('result')) {
                                next();
                            } else {
                                next('/options')
                            }
                        }
                    },
                ]
            }
        ],
    },
    {
        path: '/remote',
        component: RemoteView
    },
    {
        path: '/login',
        component: LandingView,
        children: [
            {
                path: '',
                component: Login
            },
            {
                path: '/findPassword',
                component: FindPw
            },
            {
                path: '/signUp',
                component: SignUp
            }
        ]
    }
];

export const router = new VueRouter({
    routes,
    mode: 'history',
    base: process.env.BASE_URL
});

